module.exports = __webpack_public_path__ + "static/media/1.ddf8551a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/ourGame/1.png
// module id = 154
// module chunks = 0